module.exports = __webpack_public_path__ + "img/betsize_btn.ce85f53c.png";